import React, {useEffect, useRef} from 'react';
import DataTable from 'datatables.net-dt';
import 'datatables.net-dt/css/dataTables.dataTables.min.css';
import {UserRequestData} from '../models/user';

const UserDetails = ({data}: { data: UserRequestData[] }) => {
    const tableRef = useRef<HTMLTableElement>(null);

    useEffect(() => {
        if (!tableRef.current || !data?.length) return;

        const dt = new DataTable(tableRef.current, {
            data,
            order: [[1, 'desc']],
            pageLength: 50,
            lengthMenu: [25, 50, 100],
            columns: [
                {
                    data: 'ioc',
                    title: 'IOC',
                    render: (ioc: string | {ioc: string}[]) =>
                        Array.isArray(ioc)
                            ? `<span>log file with <strong>${ioc.length}</strong> records</span>`
                            : ioc,
                },
                {data: 'request_date', title: 'Date'},
                {
                    data: null,
                    title: '',
                    orderable: false,
                    render: (_: null, __: string, row: UserRequestData) =>
                        Array.isArray(row.ioc)
                            ? '<button class="show-records-btn">Show records</button>'
                            : `<a href="/check/${row.ioc}">Check IOC</a>`,
                },
            ],
        });

        const table = tableRef.current;
        const clickHandler = (e: MouseEvent) => {
            const btn = (e.target as HTMLElement).closest('.show-records-btn');
            if (!btn) return;
            const tr = btn.closest('tr') as HTMLElement;
            const row = dt.row(tr);
            if (row.child.isShown()) {
                row.child.hide();
            } else {
                const rowData = row.data() as UserRequestData;
                const iocList = rowData.ioc as {ioc: string}[];
                const html = iocList.map(v => `<code style="margin:2px;display:inline-block">${v.ioc}</code>`).join('');
                row.child(`<div style="padding:8px">${html}</div>`).show();
            }
        };

        table.addEventListener('click', clickHandler);

        return () => {
            table.removeEventListener('click', clickHandler);
            dt.destroy();
        };
    }, [data]);

    return <table ref={tableRef} className="display" style={{width: '100%'}}/>;
};

export default UserDetails;
